module.exports = __webpack_public_path__ + "b0983d61a744961ad5d69cf1edad176a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_anna_mobile.jpg
// module id = 663
// module chunks = 0